import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";

import { Base } from "mobx-stores/_models/base";
import { Customer } from "mobx-stores/_models/customers/customer";
import { Order } from "mobx-stores/_models/orders/order";
import { WorkOrderPo } from "mobx-stores/_models/work-order-po/work-order-po";
import { WorkOrder } from "mobx-stores/_models/work-order/work-order";
import {
  DualLangInspectionNoteItem,
  IAddDualLangInspectionNoteItem,
  IUpdateDualLangInspectionNoteItem,
} from "./dual-lang-inspection-note-item";

export const DualLangInspectionNote = types
  .compose(
    Base,
    types.model({
      orderNumber: types.maybeNull(types.number),
      number: types.maybeNull(types.string),
      workOrderId: types.maybeNull(types.string),
      workOrder: types.maybeNull(WorkOrder),
      workOrderPOId: types.maybeNull(types.string),
      workOrderPO: types.maybeNull(WorkOrderPo),
      customerId: types.maybeNull(types.string),
      customer: types.maybeNull(Customer),
      inspectionDate: types.maybeNull(types.string),
      expireDate: types.maybeNull(types.string),
      conclusion: types.maybeNull(types.string),
      purchaseOrderId: types.maybeNull(types.string),
      purchaseOrder: types.maybeNull(Order),
      deliveredQuantity: types.maybeNull(types.number),
      packagesQuantity: types.maybeNull(types.string),
      quantityPerPackage: types.maybeNull(types.number),
      inspectionSamples: types.maybeNull(types.string),
      storageTemperature: types.maybeNull(types.string),
      note: types.maybeNull(types.string),
      inspector: types.maybeNull(types.string),
      expireDateText: types.maybeNull(types.string),
      items: types.optional(types.array(DualLangInspectionNoteItem), []),
    })
  )
  .actions(withSetPropAction)
  .views((self) => ({
    get orderQuantity() {
      const inspectProductId = self?.items?.[0]?.productId;
      if (!inspectProductId) return 0;

      // Prioritize workOrderPO
      const poItem = self?.workOrderPO?.purchaseOrderItem;
      if (poItem?.productId === inspectProductId) {
        return poItem.quantityStandard ?? 0;
      }

      // Fall back to workOrder
      const woItem = self?.workOrder?.items?.find(
        (x) => x.productId === inspectProductId
      );
      return woItem?.amount ?? 0;
    },
    get product() {
      return self.items?.[0]?.product;
    },
  }));
export interface IDualLangInspectionNote
  extends Instance<typeof DualLangInspectionNote> {}
export interface IDualLangInspectionNoteProperties
  extends SnapshotIn<typeof DualLangInspectionNote> {}
export interface ExtraPropertiesForDisplay {}

export interface IAddUpdateDualLangInspectionNote
  extends ExtraPropertiesForDisplay,
    Pick<
      IDualLangInspectionNoteProperties,
      | "number"
      | "expireDateText"
      | "inspectionDate"
      | "workOrderPOId"
      | "conclusion"
      | "customerId"
      | "purchaseOrderId"
      | "deliveredQuantity"
      | "packagesQuantity"
      | "quantityPerPackage"
      | "inspectionSamples"
      | "storageTemperature"
      | "note"
      | "inspector"
    > {}
export interface IAddDualLangInspectionNote
  extends IAddUpdateDualLangInspectionNote {
  items: IAddDualLangInspectionNoteItem[];
}

export interface IUpdateDualLangInspectionNote
  extends IAddUpdateDualLangInspectionNote,
    Pick<IDualLangInspectionNoteProperties, "workOrderId"> {
  id?: string | null;
  items: IUpdateDualLangInspectionNoteItem[];
}
